export default function gameReducer(state = { games: [] }, action) {
  switch (action.type) {
    case 'GAME_STARTED':
      return {
        ...state,
        games: [...state.games, action.payload]
      };
    case 'GAME_STATE':
      return {
        ...state,
        currentGameState: {
          ...state.currentGameState,
          state: action.payload 
        }
      };
    case 'GAME_FULL':
      return {
        ...state,
        currentGameState: {
          ...state.currentGameState,
          ...action.payload
        }
      };
    default:
      return state;
  }
};